import { extend } from 'flarum/common/extend';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import ItemList from 'flarum/common/utils/ItemList';
export default () => {
  // remove the unfollower, group mentioned and reply-in-category notification type from the frontend
  extend(NotificationGrid.prototype, 'notificationTypes', function(items: ItemList<any>) {
    return items.remove('newUnfollower').remove('groupMentioned').remove('newPostInTag');
  });
}
